// Importação das bibliotecas que serão utilizadas pela aplicação
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueMomentLib from 'vue-moment-lib';
import moment from 'moment';

// Importação das configurações das bibliotecas
import i18n from './i18n';
import router from './router';
import store from './store';
import filters from './filters';
import App from './App.vue';

// Importação de estilizações do sistema
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.min.css';
import 'izitoast/dist/css/iziToast.min.css';
import '@/shared/utils/favicon.js';
import '@/shared/utils/focus-application.js';
import '@/shared/utils/notification-title.js';
import '@/assets/css/components/weon-helper.css';
import '@/assets/css/components/custom-system-styles.css';
import { log, logAPI, logBus, logResponse } from '@/shared/utils/log-helper';
import { requestPermissionNotificaiton } from '@/shared/utils/browser-notify';
import movable from 'v-movable';
import sentry from '@/plugins/sentry';
import http from '@/services/http';
import 'mf-copilot/dist/style.css';

// extenção de prototype de string
import '@/shared/utils/extensions/StringExtensions';
import VueEasyLightbox from 'vue-easy-lightbox';

Vue.prototype.$http = http;

requestPermissionNotificaiton();

// Declarando uso das libs que serão utilizadas no sistema
moment.locale('pt-BR');

Vue.use(VueMomentLib, { moment });
Vue.use(Vuetify, {
  theme: (store as any).state.system.themes.weonLightMode,
  iconfont: 'mdi',
  options: {
    customProperties: true,
  },
}); // Se no futuro for ter que trocar o tema, utilizar o comando ->   'vm.$vuetify.theme = vm.$store.getters.themes.red'
Vue.use(movable);
Vue.use(VueEasyLightbox);

Vue.prototype.$log = log;
Vue.prototype.$logAPI = logAPI;
Vue.prototype.$logBus = logBus;
Vue.prototype.$logResponse = logResponse;

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

filters.forEach((f) => {
  Vue.filter(f.name, f.execute);
});

// Declaração da aplicação
Vue.config.performance = true;

sentry(Vue, router);

new Vue({
  store,
  router,
  render: (h) => h(App),
  i18n,
}).$mount('#app');
